export const PROCESS_PROCESSOR_REQUEST='PROCESS_PROCESSOR_REQUEST';
export const PROCESS_PROCESSOR_SUCCESS='PROCESS_PROCESSOR_SUCCESS';
export const PROCESS_PROCESSOR_FAILURE='PROCESS_PROCESSOR_FAILURE';

export const processProcessorRequest = (data) => ({
  type: PROCESS_PROCESSOR_REQUEST,
  payload: data,
});

export const processProcessorSuccess = (data) => ({
  type: PROCESS_PROCESSOR_SUCCESS,
  payload: data,
});


export const processProcessorFailure = (error) => ({
  type: PROCESS_PROCESSOR_FAILURE,
  payload: error,
});